import { IncomingMessage, ServerResponse } from 'http';
import Router from 'next/router';

import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

interface IRequest extends IncomingMessage {
    query?: string,
}

interface NextApiResponseWithReq extends ServerResponse {
    req: IRequest,
}

interface IRedirectingService {
    location: string,
    res?: NextApiResponseWithReq,
    httpCode: number,
}

/* @deprecated use nonPermanentRedirect or permanentRedirect */
const redirectingService = ({ res, location, httpCode }: IRedirectingService): void => {
    if (res && isServerSide()) {
        if (res.headersSent || res.writableEnded) {
            return;
        }

        const { req } = res;
        if (req) {
            const { query } = req;

            const queryParams = (new URLSearchParams(query)).toString();
            const Location = queryParams ? `${location}?${queryParams}` : location;

            res.writeHead(httpCode, { Location });
            res.end();
        }
    } else {
        Router.push(location);
    }
};

type TRedirectServiceWithCode = Omit<IRedirectingService, 'httpCode'>;

// для страницы, которая переехала навсегда
export const permanentRedirect = ({ res, location }: TRedirectServiceWithCode) => redirectingService({
    res,
    location,
    httpCode: 301,
});

// временная мера для перенаправления
export const nonPermanentRedirect = ({ res, location }: TRedirectServiceWithCode) => redirectingService({
    res,
    location,
    httpCode: 302,
});
